<template>
  <div class="customerOrder-page">
    <div class="clear">
      <h2 class="paging-title">基本信息</h2>
    </div>
    <div class="info-basic">
      <!-- 展示 -->
      <div class="look-info-box" v-if="!isEdit">
        <button class="ed" @click="isEdit=true">编辑</button>
        <ul class="item-info-ul">
          <li>
            <span class="label">企业名称：</span>
            <div class="value">{{ form.CompanyName }}</div>
          </li>
          <li>
            <span class="label">企业类型：</span>
            <div class="value">{{ form.CompanyType }}</div>
          </li>
          <li>
            <span class="label">企业账号：</span>
            <div class="value">{{ form.LoginName }}</div>
          </li>
          <li>
            <span class="label">联系人：</span>
            <div class="value">{{ form.LinkMan }}</div>
          </li>
          <li>
            <span class="label">联系方式：</span>
            <div class="value">{{ form.HandSet }}</div>
          </li>
          <li>
            <span class="label">联系人职位：</span>
            <div class="value">{{ form.LinkManPostName }}</div>
          </li>
          <li>
            <span class="label">企业所在地：</span>
            <div class="value">
              {{ form.Fulladdress }}{{ form.DetailLocation }}
            </div>
          </li>
          <li>
            <span class="label">LOGO</span>
            <img v-if="form.Logo" :src="form.Logo" alt="" class="logo" />
          </li>
        </ul>
        <ul class="item-info-ul">
          <li>
            <span class="label">所属行业：</span>
            <div class="value">{{ form.IndustryName }}</div>
          </li>
          <li>
            <span class="label">成立时间：</span>
            <div class="value">{{ form.EstablishmentTime }}</div>
          </li>
          <li>
            <span class="label">固定电话：</span>
            <div class="value">{{ form.Tel }}</div>
          </li>
          <li>
            <span class="label">企业规模：</span>
            <div class="value">{{ form.Scale | formatScale }}</div>
          </li>
          <li>
            <span class="label">注册资本：</span>
            <div class="value">{{ form.BusLicenseRegisteredCapital }}</div>
          </li>
          <li>
            <span class="label">注册地址：</span>
            <div class="value">{{ form.RegisterAddress }}</div>
          </li>
          <li>
            <span class="label">所属大区：</span>
            <div class="value">{{ form.AreaCategoryName }}</div>
          </li>
        </ul>
      </div>
      <!-- 编辑 -->
      <div class="ed-info-box" v-if="isEdit">
        <button class="ed" @click="submit">保存</button>
        <ul class="item-info-ul">
          <li>
            <span class="label">企业名称：</span>
            <div class="value">
							<el-input size="small" v-model="form.CompanyName" class="input" :disabled="true"></el-input>
						</div>
          </li>
          <li>
            <span class="label">企业类型：</span>
            <div class="value">
							<el-input size="small" v-model="form.CompanyType" class="input" :disabled="true"></el-input>
						</div>
          </li>
          <li>
            <span class="label">企业账号：</span>
            <div class="value">
							<el-input size="small" v-model="form.LoginName" class="input" :disabled="true"></el-input>
						</div>
          </li>
          <li>
            <span class="label">联系人：</span>
            <div class="value">
							<el-input size="small" v-model="form.LinkMan" class="input" :disabled="true"></el-input>
						</div>
          </li>
          <li>
            <span class="label">联系方式：</span>
            <div class="value">
							<el-input size="small" v-model="form.HandSet" class="input" :disabled="true"></el-input>
						</div>
          </li>
          <li>
            <span class="label">联系人职位：</span>
            <div class="value">
							<el-input size="small" v-model="form.LinkManPostName" class="input" :disabled="true"></el-input>
						</div>
          </li>
          <li>
            <span class="label">企业所在地：</span>
            <div class="value">
							<div class="like-input" @click="openMap">{{form.Fulladdress}}</div>
							<el-input size="small" v-model="form.DetailLocation" class="input"></el-input>
            </div>
          </li>
          <li>
            <span class="label">企业LOGO：</span>
            <div class="value">
              <el-upload
                class="logo-uploader"
                :action="UploadImg"
                :show-file-list="false"
                :on-success="uploadSuccess"
                accept="image/*">
                <img v-if="form.Logo" :src="form.Logo" class="logo">
                <i v-else class="el-icon-plus icon"></i>
              </el-upload>
            </div>
          </li>
        </ul>
        <ul class="item-info-ul">
          <li>
            <span class="label">所属行业：</span>
            <div class="value">
							<el-select v-model="form.IndustryID" placeholder="请选择" size="small" class="select">
								<el-option v-for="(item, index) in industryList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
          </li>
          <li>
            <span class="label">成立时间：</span>
            <div class="value">
							<el-date-picker
								v-model="form.EstablishmentTime"
								size="small"
                value-format="yyyy-MM-dd"
								class="date-picker"
								type="date"
								placeholder="选择日期"
							>
							</el-date-picker>
						</div>
          </li>
          <li>
            <span class="label">固定电话：</span>
            <div class="value">
							<el-input v-model="form.Tel" size="small" class="input" :disabled="false"></el-input>
						</div>
          </li>
          <li>
            <span class="label">企业规模：</span>
            <div class="value">
							<el-select v-model="form.Scale" placeholder="请选择" size="small" class="select">
								<el-option v-for="(item, index) in scaleList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
          </li>
          <li>
            <span class="label">注册资本：</span>
            <div class="value">
							<el-input v-model="form.BusLicenseRegisteredCapital" size="small" class="input" :disabled="true"></el-input>
						</div>
          </li>
          <li>
            <span class="label">注册地址：</span>
            <div class="value">
							<el-input size="small" v-model="form.RegisterAddress" class="input" disabled></el-input>
						</div>
          </li>
          <li>
            <span class="label">所属大区：</span>
            <div class="value">
							<el-select v-model="form.AreaCategory" placeholder="请选择" size="small" class="select">
								<el-option v-for="(item, index) in areaList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
          </li>
        </ul>
      </div>
    </div>
    <my-dialog class="map-dialog" :show="showMap" title="工单地址" @close="showMap=false;">
      <iframe id="map" :src="mapUrl" frameborder="0" height="500" width="100%"></iframe>
    </my-dialog>
  </div>
</template>
<script>
import { GetCompanyInfo, EditCompanyInfo,UploadImg } from "@/scripts/api.js";
import Dialog from "@/components/gkDialog.vue";
import { mapState } from "vuex";
export default {
  components: {
    "my-dialog": Dialog,
  },
  data() {
    return {
      UploadImg,
      isEdit: false,
      form: {
				Logo:'',
        CompanyName:'',
        LoginName:'',
        CompanyType:'',
        LinkMan:'',
        HandSet:'',
        LinkManPostName:'',
        IndustryName:'',
        EstablishmentTime:'',
        Tel:'',
        Scale:'',
        RegisterAddress:'',
        AreaCategoryName:'',
        AreaCategory:'',
        IndustryID:'',
        ProvinceID:'',
        CityID:'',
        CountryID:'',
        RegisterProvinceID:'',
        RegisterCityID:'',
        DetailLocation:'',
        Fulladdress:'',
        Lng:'',
        Lat:'',
        CityName:'',
			},
			industryList:[],
      showMap:false,
      scaleList:[
        {
          id:1,
          name:'大型企业（3亿以上）'
        },
        {
          id:2,
          name:'中型企业（3000-30000万）'
        },
        {
          id:3,
          name:'小型企业（3000万以下）'
        }
      ],
      areaList:[{
        name:'华中地区',
        id:1
      },{
        name:'华北地区',
        id:2
      },{
        name:'华东地区',
        id:3
      },{
        name:'华南地区',
        id:4
      },{
        name:'西北地区',
        id:5
      },{
        name:'东北地区',
        id:6
      },{
        name:'西南地区',
        id:7
      },{
        name:'华北东北',
        id:8
      },{
        name:'华东华中',
        id:9
      },{
        name:'华南西部',
        id:10
      },{
        name:'港澳台',
        id:11
      },{
        name:'境外',
        id:12
      },],
    };
  },
  filters: {
    formatScale(value) {
      let str = "";
      switch (value) {
        case 1:
          str = "大型企业（3亿以上）";
          break;
        case 2:
          str = "中型企业（3000-30000万）";
          break;
        case 3:
          str = "小型企业（3000万以下）";
          break;
      }
      return str;
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    //地图地址
    mapUrl(){
      let url=`${location.protocol}//${location.host}${location.pathname}#/baiduMap?userType=${this.userInfo.LoginAccountType}&userId=${this.userInfo.LoginAccountId}`;
      return url;
    }
  },
  async created () {
    this.init();
		this.industryList= await this.$store.dispatch('loadIndustryList');
  },
  mounted() {
    this.receiveData();
  },
  methods: {
    init() {
      GetCompanyInfo({ CompanyId: this.userInfo.LoginAccountId }).then((r) => {
        if (r.Result == 1) {
          this.form = r.Data;
        } else {
          this.$toast(r.Message);
        }
      });
    },
    //打开地图
    openMap(){
      this.showMap=true;
      let data={
        FullAddress:this.form.Fulladdress,
        Lat:this.form.Lat,
        Lng:this.form.Lng,
        CityName:this.form.CityName,
      }
      this.$nextTick(()=>{
        if(data){
          document.getElementById('map').contentWindow.postMessage(JSON.stringify(data),'*');
        }
      })
    },
    //接受iframe传出来的信息
    receiveData(){
      let that=this;
      window.addEventListener('message',function(e) {
        let data={};
        let value=e.data;
        if(that.$isJsonString(value)){
          data=JSON.parse(value);
        }
        if(data.FullAddress){
          that.form.Fulladdress=data.FullAddress;
          that.form.Lat=data.Lat;
          that.form.Lng=data.Lng;
          that.form.CityName=data.CityName;
        }
        that.showMap=false;
      })
    },
    //上传之前
    beforeUpload(file){
      console.log(file);
    },
    //上传后
    uploadSuccess(res){
      if(res.Result==1){
        this.form.Logo=res.Data[0].imgUrl;
      }else{
        this.$toast(res.Message)
      }
    },
		submit(){
			EditCompanyInfo({
        ...this.form,
        CompanyId:this.userInfo.LoginAccountId
      }).then(r=>{
        this.$toast(r.Message);
        if(r.Result==1){
          this.isEdit=false;
          this.init();
        }
      })
		}
  },
};
</script>
<style lang="scss">
.info-basic {
  background: #f9f9f9;
  position: relative;
  padding: 30px 20px;
  margin-top: 30px;
  .look-info-box,
  .ed-info-box {
    overflow: hidden;
  }
  .ed {
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 1;
    color: #f75959;
    background: none;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .item-info-ul {
		float: left;
		width: 50%;
    li {
			overflow: hidden;
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 10px;
			padding-top: 5px;
			padding-bottom: 5px;
      .label {
        white-space: nowrap;
        text-align: right;
        width: 110px;
        padding-right: 30px;
        color: #999;
				float: left;
      }
      .value {
        color: #666;
        font-weight: bold;
				float: left;
				width: 360px;
      }
			.logo{
				float: left;
				width: 100px;
				height: 100px;
			}
    }
  }
  .ed-info-box {
		.label {
			white-space: nowrap;
			text-align: right;
			width: 110px;
			padding-right: 30px;
			color: #999;
			float: left;
		}
		.value{
				float: left;
				width: 360px;
		}
    .logo-uploader{
      width: 100px;
      height: 100px;
      .icon{
        width: 100px;
        height: 100px;
        border:1px solid #e5e5e5;
        font-size: 24px;
        color: #e5e5e5;
        line-height: 100px;
        text-align: center;
        cursor: pointer;
        background-color: #fff;
      }
    }
		.like-input{
			background-color: #fff;
			border-radius: 0px;
			border: 1px solid #DCDFE6;
			color: #606266;
			font-size: inherit;
			font-weight: normal;
			height: 32px;
			line-height: 32px;
			outline: 0;
			padding: 0 15px;
			width: 100%;
			margin-bottom: 10px;
			cursor: pointer;
		}
    .input,
    .select,
    .date-picker {
			width: 100%;
    }
    .tips {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      color: #999;
      line-height: 32px;
    }
  }
}
</style>
